/**
 * Color Manipulation Utilities
 * Theme-aware color helpers for consistent color operations across components
 */

export const darkenHex = (hex: string, amount: number): string => {
  const num = parseInt(hex.replace('#', ''), 16);

  const r = Math.max(0, (num >> 16) - Math.round(255 * amount));

  const g = Math.max(0, ((num >> 8) & 0x00ff) - Math.round(255 * amount));

  const b = Math.max(0, (num & 0x0000ff) - Math.round(255 * amount));

  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
};

export const isLightColor = (hex?: string): boolean => {
  if (!hex) return true;
  const num = parseInt(hex.replace('#', ''), 16);

  const r = (num >> 16) & 255;

  const g = (num >> 8) & 255;

  const b = num & 255;
  // Luminance formula: (R*299 + G*587 + B*114) / 1000
  const luminance = (r * 299 + g * 587 + b * 114) / 1000;
  return luminance > 128;
};

export const ColorHelpers = {
  darkenHex,
  isLightColor,
};
